import React from 'react';
import { Quote } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-14 md:py-16 border-y border-white/5 bg-surface/30 relative" data-id="element-424">
      <div className="absolute inset-0 pointer-events-none opacity-50" aria-hidden="true" style={{
      background: 'radial-gradient(ellipse 40% 60% at 50% 50%, rgba(212, 168, 67, 0.04) 0%, transparent 70%)'
    }} data-id="element-425" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-426">
        <FadeIn data-id="element-427">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-14" data-id="element-428">
            <div className="flex flex-col items-center text-center px-4" data-id="element-429">
              <span className="text-2xl mb-2" aria-hidden="true" data-id="element-430">
                🏭
              </span>
              <span className="text-4xl md:text-5xl font-heading font-extrabold gold-gradient-text leading-none" data-id="element-431">
                +150
              </span>
              <span className="text-xs text-gray-400 uppercase tracking-widest mt-2" data-id="element-432">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-433">
              <span className="text-2xl mb-2" aria-hidden="true" data-id="element-434">
                📚
              </span>
              <span className="text-4xl md:text-5xl font-heading font-extrabold gold-gradient-text leading-none" data-id="element-435">
                6
              </span>
              <span className="text-xs text-gray-400 uppercase tracking-widest mt-2" data-id="element-436">
                Módulos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-437">
              <span className="text-2xl mb-2" aria-hidden="true" data-id="element-438">
                🎁
              </span>
              <span className="text-4xl md:text-5xl font-heading font-extrabold gold-gradient-text leading-none" data-id="element-439">
                3
              </span>
              <span className="text-xs text-gray-400 uppercase tracking-widest mt-2" data-id="element-440">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-441">
              <div className="flex gap-1 mb-2" data-id="element-442">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-base" data-id="element-443">
                    ★
                  </span>)}
              </div>
              <span className="text-4xl md:text-5xl font-heading font-extrabold gold-gradient-text leading-none" data-id="element-444">
                4.9
              </span>
              <span className="text-xs text-gray-400 uppercase tracking-widest mt-2" data-id="element-445">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-446">
          {[{
          text: 'Calculé el primer DVH con las tablas y no tuve que usar la calculadora. Las fórmulas de descuento me cambiaron la vida.',
          name: 'Marcos T.',
          loc: 'Córdoba',
          initial: 'M'
        }, {
          text: 'Le pasé las planillas a mi ayudante y trabajó solo toda la semana. Por primera vez no tuve que estar encima de todo.',
          name: 'Roberto G.',
          loc: 'Rosario · Tallerista de PVC',
          initial: 'R'
        }, {
          text: 'El Módulo 6 de instalación me eliminó las filtraciones. No tuve un solo reclamo en los últimos 4 meses.',
          name: 'Ariel M.',
          loc: 'Buenos Aires · Instalador PVC + DVH',
          initial: 'A'
        }].map((t, i) => <FadeIn key={i} delay={0.1 + i * 0.1} data-id="element-447">
              <div className="bg-bg/60 backdrop-blur p-7 rounded-2xl border border-white/10 hover:border-gold/30 transition-colors h-full flex flex-col relative" data-id="element-448">
                <Quote className="w-7 h-7 text-gold/30 mb-3" data-id="element-449" />
                <div className="flex gap-1 mb-4" data-id="element-450">
                  {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-sm" data-id="element-451">
                      ★
                    </span>)}
                </div>
                <p className="text-gray-200 italic mb-6 flex-grow leading-relaxed" data-id="element-452">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 pt-5 border-t border-white/5" data-id="element-453">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center font-bold text-bg text-lg" data-id="element-454">
                    {t.initial}
                  </div>
                  <div data-id="element-455">
                    <p className="font-bold text-white text-sm" data-id="element-456">{t.name}</p>
                    <p className="text-xs text-gray-400" data-id="element-457">{t.loc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}